import ElMenuItemGroup from '../menu/MenuItemGroup'

/* istanbul ignore next */
ElMenuItemGroup.install = function (app) {
  app.component(ElMenuItemGroup.name, ElMenuItemGroup)
}

export default ElMenuItemGroup
